import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import PrimeVue from "primevue/config";

import "primeflex/primeflex.css";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

import Divider from 'primevue/divider';
import Button from 'primevue/button'
import Breadcrumb from 'primevue/breadcrumb';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Row from 'primevue/row';       
import Panel from 'primevue/panel';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import Inplace from 'primevue/inplace';
import ToastService from 'primevue/toastservice';
import ToastPrime from 'primevue/toast';
import Image from 'primevue/image';
import ListBox from 'primevue/listbox';
import FileUpload from 'primevue/fileupload';
import ChipPrime from 'primevue/chip';
import ProgressSpinner from 'primevue/progressspinner';
import Textarea from 'primevue/textarea';
import Checkbox from 'primevue/checkbox';
import Chart from 'primevue/chart';
import Card from 'primevue/card';

import DialogPrime from 'primevue/dialog';
import SelectButton from 'primevue/selectbutton';

import Tooltip from "primevue/tooltip";
import Ripple from "primevue/ripple";
import BadgeDirective from "primevue/badgedirective";
import StyleClass from "primevue/styleclass";


import i18n from "@/plugins/i18n"

const app = createApp(App)
app.use(router)
app.use(store)
app.use(i18n)
app.use(PrimeVue)
app.use(ToastService);

app.directive("tooltip", Tooltip);
app.directive("badge", BadgeDirective);
app.directive("ripple", Ripple);
app.directive("styleclass", StyleClass);

app.component('DividerPrime', Divider);
app.component('PanelPrime', Panel);
app.component('ButtonPrime', Button);
app.component('BreadcrumbPrime', Breadcrumb);
app.component('DataTablePrime', DataTable);
app.component('ColumnPrime', Column);
app.component('ColumnGroupPrime', ColumnGroup);
app.component('RowPrime', Row);
app.component('InputTextPrime', InputText);
app.component('InputNumberPrime', InputNumber);
app.component('DropdownPrime', Dropdown);
app.component('CalendarPrime', Calendar);
app.component('InplacePrime', Inplace);
app.component('ToastPrime', ToastPrime);
app.component('ImagePrime', Image);
app.component('DialogPrime', DialogPrime);
app.component('SelectButton', SelectButton);
app.component('ListBox', ListBox);
app.component('FileUpload', FileUpload);
app.component('ChipPrime', ChipPrime);
app.component('ProgressSpinner', ProgressSpinner);
app.component('TextareaPrime', Textarea);
app.component('CheckboxPrime', Checkbox);
app.component('ChartPrime', Chart);
app.component('CardPrime', Card);

app.mount('#app')
